export const avoltaSDK: ISdkResource = {
  type: "built-in",
  goBackHome: () => {
    window.open("dufryred://entertainment", "_self");
  },
};

export default avoltaSDK;
